import type { EntityRoles } from "shared/types";

export const isRoleAvailable = (userRoles: EntityRoles[], acceptedRoles: EntityRoles[]) =>
	userRoles.some(role => acceptedRoles.includes(role));
